import { render, staticRenderFns } from "./user_shopcart_bundle_order_list.vue?vue&type=template&id=ed6dd496&"
import script from "./user_shopcart_bundle_order_list.vue?vue&type=script&lang=js&"
export * from "./user_shopcart_bundle_order_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports